import React from 'react';
import { TableSortLabel, TableSortLabelProps } from '@material-ui/core';

export function PasslyTableSortLabel(props: TableSortLabelProps) {
    const getIconStyle = () => {
        const className = props.direction === 'asc' ? 'passlyTable__container-asc' : 'passlyTable__container-desc';

        return (
            <div className={`passlyTable__container ${props.active ? className : ''}`}>
                <i className='fa-solid fa-caret-up' />
                <i className='fa-solid fa-caret-down' />
            </div>
        );
    };
    return <TableSortLabel IconComponent={() => getIconStyle()} {...props} />;
}
